import { useNavigate } from 'react-router-dom';

export default function FeaturedShops() {
  const navigate = useNavigate();

  const shops = [
    {
      name: '다움네일살롱',
      location: '강남',
      specialty: '프렌치네일 디자인으로 유명한 프리미엄 샵',
      rating: 4.9,
      reviews: 328,
      image: 'https://public.readdy.ai/ai/img_res/36b93275d52769ec6fd432158d4287f3.jpg'
    },
    {
      name: '라벤더 아이래쉬',
      location: '홍대',
      specialty: '자연스러운 속눈썹 연장 전문',
      rating: 4.8,
      reviews: 256,
      image: 'https://readdy.ai/api/search-image?query=Modern%20eyelash%20extension%20salon%20with%20soft%20lavender%20and%20white%20tones%2C%20comfortable%20treatment%20bed%2C%20professional%20lighting%2C%20minimalist%20beauty%20studio%2C%20elegant%20feminine%20design%2C%20premium%20lash%20service%20space%2C%20serene%20atmosphere%2C%20clean%20aesthetic&width=600&height=400&seq=shop-lash-1&orientation=landscape'
    },
    {
      name: '로즈 스킨케어',
      location: '압구정',
      specialty: '맞춤형 피부관리와 힐링 케어',
      rating: 5.0,
      reviews: 412,
      image: 'https://readdy.ai/api/search-image?query=Premium%20skincare%20spa%20room%20with%20rose%20gold%20accents%2C%20soft%20pink%20lighting%2C%20luxury%20facial%20treatment%20bed%2C%20elegant%20minimalist%20interior%2C%20professional%20beauty%20clinic%2C%20warm%20beige%20tones%2C%20sophisticated%20wellness%20space%2C%20serene%20healing%20atmosphere&width=600&height=400&seq=shop-skin-1&orientation=landscape'
    },
    {
      name: '블룸 왁싱 스튜디오',
      location: '신사',
      specialty: '프라이빗한 공간에서 편안한 왁싱',
      rating: 4.9,
      reviews: 189,
      image: 'https://readdy.ai/api/search-image?query=Private%20waxing%20studio%20with%20soft%20pastel%20colors%2C%20clean%20modern%20design%2C%20comfortable%20treatment%20room%2C%20professional%20beauty%20space%2C%20minimalist%20aesthetic%2C%20warm%20lighting%2C%20elegant%20feminine%20interior%2C%20premium%20personal%20care%20salon&width=600&height=400&seq=shop-wax-1&orientation=landscape'
    },
    {
      name: '페탈 헤어살롱',
      location: '청담',
      specialty: '트렌디한 컷과 컬러 전문',
      rating: 4.8,
      reviews: 294,
      image: 'https://readdy.ai/api/search-image?query=Chic%20hair%20salon%20with%20pastel%20pink%20and%20beige%20interior%2C%20modern%20styling%20stations%2C%20elegant%20mirrors%2C%20professional%20beauty%20space%2C%20sophisticated%20feminine%20design%2C%20soft%20ambient%20lighting%2C%20premium%20hairdressing%20studio%2C%20minimalist%20aesthetic&width=600&height=400&seq=shop-hair-1&orientation=landscape'
    },
    {
      name: '오로라 메이크업',
      location: '가로수길',
      specialty: '웨딩 및 특별한 날 메이크업',
      rating: 5.0,
      reviews: 167,
      image: 'https://readdy.ai/api/search-image?query=Elegant%20makeup%20studio%20with%20soft%20lighting%2C%20professional%20vanity%20mirror%2C%20pastel%20pink%20and%20gold%20accents%2C%20luxury%20cosmetics%20display%2C%20sophisticated%20beauty%20space%2C%20feminine%20minimalist%20design%2C%20premium%20bridal%20makeup%20room%2C%20warm%20atmosphere&width=600&height=400&seq=shop-makeup-1&orientation=landscape'
    }
  ];

  const handleBooking = (shopId: number) => {
    window.REACT_APP_NAVIGATE(`/booking?shopId=${shopId}`);
  };

  const handleViewMore = () => {
    navigate('/nearby-shops');
  };

  return (
    <section id="shops" className="py-24 px-6 bg-gradient-to-b from-white to-pink-50/30">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-light text-gray-800 mb-4" style={{ fontFamily: 'Playfair Display, serif' }}>
            Featured Shops
          </h2>
          <p className="text-base text-gray-600">엄선된 프리미엄 뷰티샵을 만나보세요</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {shops.map((shop, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl overflow-hidden hover:shadow-2xl transition-all duration-300 cursor-pointer"
            >
              <div className="relative w-full h-64 overflow-hidden">
                <img
                  src={shop.image}
                  alt={shop.name}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm px-3 py-1.5 rounded-full flex items-center space-x-1">
                  <i className="ri-star-fill text-yellow-400 text-sm"></i>
                  <span className="text-sm font-medium text-gray-800">{shop.rating}</span>
                </div>
              </div>

              <div className="p-6">
                <div className="flex items-center space-x-2 mb-3">
                  <span className="text-xs font-medium text-rose-400 bg-rose-50 px-3 py-1 rounded-full">
                    {shop.location}
                  </span>
                  <span className="text-xs text-gray-500">리뷰 {shop.reviews}개</span>
                </div>

                <h3 className="text-xl font-medium text-gray-800 mb-2">{shop.name}</h3>
                <p className="text-sm text-gray-600 mb-6 leading-relaxed">{shop.specialty}</p>

                <button 
                  onClick={() => handleBooking(shop.id)}
                  className="w-full py-3 bg-gradient-to-r from-rose-400 to-pink-400 text-white text-sm font-medium rounded-full hover:shadow-lg hover:scale-105 transition-all whitespace-nowrap cursor-pointer"
                >
                  예약하기
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <button 
            onClick={handleViewMore}
            className="px-8 py-3 border-2 border-rose-400 text-rose-400 text-sm font-medium rounded-full hover:bg-rose-400 hover:text-white transition-all whitespace-nowrap cursor-pointer"
          >
            더 많은 뷰티샵 보기
          </button>
        </div>
      </div>
    </section>
  );
}
